import React from "react";
import { Outlet } from "react-router-dom";
import HeaderAuth from "../global/header/HeaderAuth";
import FooterAuth from "../global/footer/FooterAuth";

function RootAuth() {
  return (
    <>
      <HeaderAuth />
      <Outlet />
      <FooterAuth />
    </>
  );
}

export default RootAuth;
